import { Schema } from "@upserve/cold-storage";
import { Maybe } from "true-myth";

import { IUser } from "types/user";
import { maybetype } from "helpers/schema";

const { parseBySchema, jsontype } = Schema;

export interface ITransformedUser {
  email: string;
  firstName: Maybe<string>;
  lastName: Maybe<string>;
}

const userSchema: ITransformedUser = {
  email: jsontype("string"),
  firstName: maybetype(jsontype("string")),
  lastName: maybetype(jsontype("string")),
};

function transformUser(user: IUser): ITransformedUser {
  return parseBySchema(userSchema)(user);
}

export { transformUser };
